import {
    Avatar,
    Box, Button,
    Card,
    CardContent,
    CardHeader,
    Divider,
    Fade,
    IconButton, Table, TableCell, TableHead, TableRow,
    Typography,
    useMediaQuery
} from "@mui/material";
import {Edit, House, Person} from "@mui/icons-material";
import SimpleTypography from "../../../../components/Shared/SimpleTypography";
import Masks from "../../../../components/Shared/Masks";
import React, {useContext} from "react";
import {useNavigate, useParams} from "react-router-dom";
import Context from "../../../../contexts/Context";

const RenterInfo = (
  {
    reqData,
    setFilters,
    isLoading,
    unitInfo,


  }
) => {
  const params = useParams()
  const { setDataProvider } = useContext(Context)

  const sizeMatch = useMediaQuery('@media (min-width:730px)')
    const navigate = useNavigate()
  return (

    <Card
        sx={{mt:"1rem", mb:"1rem"}}
    >
        <CardHeader
            avatar={<Avatar sx={{bgcolor: 'primary.main'}}><Person/></Avatar>}
            title={'Cliente'}

            action={
                <Button
                    onClick={() => {
                        if (reqData?.unit?.id) {
                            navigate(`/alugueis/imoveis/${reqData.unit.id}/editar`)
                        }
                    }}
                    size={"small"}
                    sx={{
                        alignSelf: 'center'   // 🔥 centraliza verticalmente
                    }}
                >
                    ver cliente
                </Button>
            }
            sx={{
                '& .MuiCardHeader-action': {
                    alignSelf: 'center',     // 🔥 garante centralização
                    marginTop: 0             // remove ajuste automático
                }
            }}

        />
        <Divider
            sx={{
                mt: '0.7rem',
                mb: '1rem'
            }}
        />


      <CardContent>
          <SimpleTypography
              label={'Nome'}
              isLoading={isLoading}
              directValue={reqData?.name}
              labelStyles={{
                  fontWeight: 'bold'
              }}
              boxStyles={{
                  width: '100%',
                  mb: '1rem'
              }}
          />
        <SimpleTypography
          label={'CPF / CNPJ'}
          isLoading={isLoading}
          directValue={Masks?.cpfOrCnpjText(params?.id ? reqData?.cpf_cnpj?.toString() : unitInfo?.cpf?.toString() ?? '') ?? ''}
          labelStyles={{
            fontWeight: 'bold'
          }}
          boxStyles={{
            width: '100%',
            mb: '1rem'
          }}
        />

          <SimpleTypography
              label={'Telefone'}
              isLoading={isLoading}
              directValue={Masks?.phone(unitInfo?.phone?.toString() ?? '') ?? ''}
              labelStyles={{
                  fontWeight: 'bold'
              }}
              boxStyles={{
                  width: '100%',
                  mb: '1rem'
              }}
          />

          <SimpleTypography
              label={'E-mail'}
              isLoading={isLoading}
              directValue={unitInfo?.email?.toString() ?? ''}
              labelStyles={{
                  fontWeight: 'bold'
              }}
              boxStyles={{
                  width: '100%',
                  mb: '1rem'
              }}
          />

        {unitInfo?.street && unitInfo?.number &&
          <SimpleTypography
            label={'Endereço'}
            isLoading={isLoading}
            directValue={`${unitInfo.street}, ${unitInfo.number}${unitInfo.complement ? `, ${unitInfo.complement}` : ''}`}
            labelStyles={{
              fontWeight: 'bold'
            }}
            boxStyles={{
              width: '100%',
              mb: '1rem'
            }}
          />
        }

        {unitInfo?.district &&
          <SimpleTypography
            label={'Bairro'}
            isLoading={isLoading}
            directValue={`${unitInfo.district}`}
            labelStyles={{
              fontWeight: 'bold'
            }}
            boxStyles={{
              width: '100%',
              mb: '1rem'
            }}
          />
        }


      </CardContent>
    </Card>

  )
}

export default RenterInfo